import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, MenuController, Events } from 'ionic-angular';
import { UserAsset as User, } from '@providers/index';


import { HomePage } from '../home/home';
@Component({
  selector: 'page-login',
  templateUrl: 'page.html'
})
export class LoginPage {

  form={
    username:'',
    password:''
  };
  loading:any;


  selectedAnimation: any = "other";
  animations: any;
  interactive = true;
  anim: any;
  animationSpeed: number = 1;

  interactiveAnimationOption = {
    loop            : true,
    prerender       : false,
    autoplay        : false,
    autoloadSegments: false,
    path            : 'assets/animations/other/jake.json'
  }

  otherAnimations = [
    {
      path: 'assets/animations/other/verification.json'
    }
  ]

  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    private alertCtrl  : AlertController,
    private toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    private menuCtrl   : MenuController,
    public  events     : Events,
    public  userApi    : User,
  ) {    
    this.changeAnimations();
  }

  ionViewWillEnter() {
    let mainPage = localStorage.getItem("mainPage");
    if(localStorage.form_login!=undefined){
      this.doLogin(1);
      localStorage.setItem("mainPage", mainPage);
    }else{
      localStorage.clear();
      localStorage.setItem("mainPage", mainPage);
      this.menuCtrl.enable(false, 'MainMenu');
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message : msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  doLogin(check=0){
    this.showLoading();

    if(check){
      this.form = JSON.parse(localStorage.form_login);
    }
    let params = this.form;

    this.userApi.login(params).subscribe((resp:any) => {
      // this.presentToast(resp.msg);
      this.loading.dismiss();
      if(resp.success){
        localStorage.is_login=1;
        localStorage.form_login=JSON.stringify(this.form);
        localStorage.data_user=JSON.stringify(resp);
        this.setSession();
        this.menuCtrl.enable(true, 'MainMenu');
        //this.navCtrl.push(HomePage);
      }
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });    
  }

  setSession(){
    let resp = JSON.parse(localStorage.data_user);

    this.userApi.is_login=1;
    this.userApi.data=resp.data;
    this.userApi.group = resp.group;
    this.userApi.onesignal_app_id=resp.onesignal_app_id;
    let akses = {};
    resp.fitur.forEach(rec => {
      akses[rec.fitur_app] = true;
      akses[rec.fitur_app+"_fitur_data"] = rec.fitur_data;
      akses[rec.fitur_app+"_fitur_group"] = rec.group_data;
    });
    this.userApi.akses = akses;
    setTimeout(() => {
      this.events.publish('user:access_asset', resp);
    }, 2000);
    
  }

  handleAnimation(anim) {
    this.anim = anim;
  }

  stop() {
      this.anim.stop();
  }

  
  setSpeed() {
      this.anim.setSpeed(this.animationSpeed);
  }

  animate() {
    this.anim.playSegments([[27, 142], [14, 26]], true);
  }

  changeAnimations() {
    this.interactive = false;
    switch (this.selectedAnimation) {
      case "other":
        this.animations = this.otherAnimations;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/login/page.ts